import React from 'react';
import NavTagline from '../nav-tagline/nav-tagline';
import Footer from './Footer';


const SystemOutage = () => (
    <main className="SystemOutage layout-container" aria-labelledby="systemOutageHeading">
        <NavTagline />
        <div className="container ctr">
            <div className="text-size3 or-clr"><i className="bi bi-cone-striped" aria-hidden="true"></i></div>
            <p
                className="text-size4"
                id="systemOutageHeading">We apologize for any inconvenience as we are experiencing technical difficulties. We are working quickly as possible to resolve the issue.
            </p>
            <div className="text-size9 sp-margin10">
                If you need immediate support, please call{" "} <a href="tel:18884709913" aria-label="Call support at 1-888-470-9913">1.888.470.9913</a>{" "} or email us at{" "} <a href="mailto: support@secureexsolutions.com" aria-label="Email support at support@secureexsolutions.com">support@secureexsolutions.com</a>.
            </div>
        </div>
        <Footer />
  </main>
);


export default SystemOutage;
